import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.018,
      delayChildren: 0.06,
    },
  },
};

const charVariants = {
  hidden: {
    opacity: 0,
    y: 12,
    filter: 'blur(5px)',
  },
  visible: {
    opacity: 1,
    y: 0,
    filter: 'blur(0px)',
    transition: {
      duration: 0.48,
      ease: [0.22, 1, 0.36, 1],
    },
  },
};

/**
 * 서브 페이지 상단 `page-top-intro` 한 줄용. 한 글자씩 짧게 떠오르는 인트로.
 * @param {{ text: string }} props
 */
const PageTopIntroLine = ({ text }) => {
  const reduceMotion = useReducedMotion();
  const chars = Array.from(text);

  if (reduceMotion) {
    return <p className="page-top-intro__line">{text}</p>;
  }

  return (
    <motion.p
      className="page-top-intro__line page-top-intro__line--motion"
      variants={containerVariants}
      initial="hidden"
      animate="visible"
      aria-label={text}
    >
      {chars.map((char, i) => (
        <motion.span
          key={`${i}-${char}`}
          variants={charVariants}
          className="page-top-intro__glyph"
          aria-hidden="true"
        >
          {char === ' ' ? '\u00a0' : char}
        </motion.span>
      ))}
    </motion.p>
  );
};

export default PageTopIntroLine;
